<template>
<main>
   <section id="uebermich" aria-label="&Uuml;ber mich">
      <div class="blue-box">
        <div class="flex-group">
          <!-- <div class="content-container"> -->
            <div class="text text-wide">
              <h1>Kurs-Termine</h1>

               <ul class="termin-list ">
                    <!-- <li>
                        <h4>06.05.2023<br>NEURO-RIDER® Training am Reitsimulator.Wien</h4>
                        <div class="text-center">
                          <img src="../assets/img/termine/2.png" width="300" alt=""><br>
                          <span class="btn-red">
                            <a href="https://fb.me/e/Nzq7LSe0">Infos und Anmeldung</a>
                          </span>
                        </div>
                
                    </li> -->
                    <li>
                        <h4>22.10.2023 in Oberndorf an der Melk/NÖ<br>Die Atmung des Reiters - Zwerchfell und Beckenboden im Einklang nach der Franklin-Methode®</h4>
                        <div class="text-center">
                          <img src="../assets/img/termine/7.png" width="300" alt=""><br>
                          <span class="btn-red">
                            <a href="https://fb.me/e/2OLCc54Ay">Infos und Anmeldung</a>
                            
                          </span>
                        </div>
                        
                    </li>
                    <li>
                        <h4>26.10.2023<br>NEURO-RIDER® Training am Reitsimulator.Wien</h4>
                        <div class="text-center">
                          <img src="../assets/img/termine/8.jpg" width="300" alt=""><br>
                          <p>! Anmeldung über Reitsimulator.Wien</p>
                          <span class="btn-red">
                            <a href="https://www.reitsimulator.wien/kurse/neuro-rider/">Infos und Anmeldung</a>
                          </span>
                        </div>
                
                    </li>
                    <!-- <li>
                        <h4>29.04., 20.05. und 10.06.2023 in Wr. Neustadt/NÖ<br>6-wöchiger Intensivkurs - Besser Reiten mit Neuro-Athletik Training</h4>
                        <div class="text-center">
                          <img src="../assets/img/termine/4.png" width="300" alt=""><br>
                          <span class="btn-red">
                            <a href="https://fb.me/e/OLSMd0j7">Infos und Anmeldung</a>
                          </span>
                        </div>
                        
                    </li>
                    <li>
                        <h4>14.-16.07.2023 in Velm/NÖ<br>Koordination und Balance - Besser Reiten mit Neuro-Athletik Training</h4>
                        <div class="text-center">
                          <img src="../assets/img/termine/3.png" width="300" alt=""><br>
                          <span class="btn-red">
                            <a href="https://fb.me/e/VdwZS4m6">Infos und Anmeldung</a>
                          </span>
                        </div>
                        
                    </li>
                    <li>
                        <h4>29.-30.07.2023 in Kirnberg an der Mank/NÖ<br> Pferde in Bewegung beurteilen</h4>
                        <div class="text-center">
                          <img src="../assets/img/termine/5.png" width="300" alt=""><br>
                          <span class="btn-red">
                            <a href="https://fb.me/e/YMOrLSXf">Infos und Anmeldung</a>
                          </span>
                        </div>
                        
                    </li>
                    <li>
                        <h4>22.-24.09.2023 in Gammelsdorf/Bayern<br>Koordination und Balance - Besser Reiten mit Neuro-Athletik Training</h4>
                        <div class="text-center">
                          <img src="../assets/img/termine/6.png" width="300" alt=""><br>
                           <span class="btn-red">
                            <a href="https://fb.me/e/3yAOqjMy1">Infos und Anmeldung</a>
                          </span>
                        </div>

                    </li>
                     -->

                  </ul>
            </div>
 
        </div>
      </div>
    </section>

  <section id="organisation">
      <div class="red-box">
        <div class="flex-group">
          <!-- <div class="content-container"> -->
            <div class="text">
              <h3>Kurse bei dir im Stall</h3>
              <p>
               Du möchtest gerne einen Kurs bei dir organisieren?
               Melde dich bei mir, wir finden zusammen Möglichkeiten!
              </p>
              <p>Unter anderem folgenden Themen sind möglich:</p>
              <ul>
                <li>Reitkurse bzw. Sitzschulung</li>
                <li>Lektionen richtig reiten</li>
                <li>Imagination und verkörperte Anatomie für Reiter</li>
                <li>Neuro-Athletik Training mit unterschiedlichen Schwerpunkten</li>
                <li>Bewegungsabläufe des Pferdes verstehen, analysieren und verändern</li>
                <li>Körperarbeit und Körpersprache des Pferdes</li>
                <li>Blickschulung - Gesundes Training vom Boden</li>
                <li>Trainingsaufbau und Trainingskonzepte</li>
                <li>und vieles mehr</li>
              </ul>
            </div>

            <div>
              <img src="../assets/img/home/angebot-mobil2.png" alt="">
            </div>
          </div>
        </div>
    </section>

  </main>

</template>

<script>
export default {
  name: "Termine", //this is the name of the component
  
  mounted () {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
  },
  created() {
    // Watch URL changes Hashs - scrollTo
    this.$watch(
      () => this.$route.hash,
      () => {
        setTimeout(() => this.scrollTo(this.$route.hash), 1)
      }
    )
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    },

    scrollToAnchorPoint(refName) {
        const el = this.$refs[refName]
        el.scrollIntoView({ behavior: 'smooth'})
    }
  
  },
  metaInfo() {
      return { 
          title: "Termine Pferdeverstand - Sabine D&ouml;br&ouml;ssy",
          meta: [
              { name: 'description', content: 'Pferdeverstand.at - Training und Gesundheit für Reiter und Pferd' },
              { property: 'og:title', content: "Pferdeverstand.at - für alle, die mit ihrem Pferd weiterkommen wollen."},
              { property: 'og:description', content: 'Training und Gesundheit für Reiter und Pferd'},
              { property: 'og:image', content: '../assets/img/og/pferdeverstand-logo.png'},
              { property: 'og:url', content: 'www.pferdeverstand.at'}

          ]
      }
  }
};

// TODO: meta
</script>


<style></style>



// WEBPACK FOOTER //
// src/components/Termine.vue